import { render, staticRenderFns } from "./product_setting_btn.vue?vue&type=template&id=2215f922&scoped=true&"
import script from "./product_setting_btn.vue?vue&type=script&lang=js&"
export * from "./product_setting_btn.vue?vue&type=script&lang=js&"
import style0 from "./product_setting_btn.vue?vue&type=style&index=0&id=2215f922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2215f922",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2215f922', component.options)
    } else {
      api.reload('2215f922', component.options)
    }
    module.hot.accept("./product_setting_btn.vue?vue&type=template&id=2215f922&scoped=true&", function () {
      api.rerender('2215f922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/emap/render_custom_plugin/product_setting_btn.vue"
export default component.exports